const initialState = {
  data: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_IPO_DATA":
      return {
        ...state,
        data: { ...state.data, ...action.data },
      };
    case "SET_IPO_CONTRACTS":
      return {
        ...state,
        data: { ...state.data, contracts: action.data },
      };
    case "REMOVE_IPO_DETAILS":
      return {
        ...state,
        data: null,
      };
    case "SET_IPO_CONFIG":
      return {
        ...state,
        ipoConfig: action.data,
      };

    case "REMOVE_IPO_CONFIG":
      return {
        ...state,
        ipoConfig: null,
      };
    default:
      return state;
  }
}
